import axios from "axios";

const defaultPostOptions = {
  method: "Post",
  maxBodyLength: Infinity,
  headers: {
    "Content-Type": "application/json",
  },
};

const createCorrectiveAction = (context, event) => {
  try {
    const options = {
      ...defaultPostOptions,
      headers: {
        ...defaultPostOptions.headers,
        Authorization: `Bearer ${context.authentication.token}`,
      },
      data: JSON.stringify(context?.changeSet),
    };
    return axios(
      `${context.qmsToolApiUrl}reports/${context?.loadRequest.reportId}/corrective-actions`,
      options,
    ).then((response) => response?.data?.corrective_actions);
  } catch (error) {
    return Promise.reject(error);
  }
};

export { createCorrectiveAction };
